interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  tone?: "brand" | "inverse";
  label?: string;
  children?: never;
}

const SIZE = {
  sm: "h-4 w-4 border-2",
  md: "h-8 w-8 border-[3px]",
  lg: "h-12 w-12 border-4",
} as const;

export function Spinner({ size = "md", tone = "brand", label = "Loading" }: SpinnerProps) {
  const color = tone === "inverse" ? "border-white border-t-transparent" : "border-brand-green border-t-transparent";

  return <span role="status" aria-label={label} className={`inline-block animate-spin rounded-full ${SIZE[size]} ${color}`} />;
}
